import React, { useState, useEffect, useRef } from 'react';
import { Spinner, Container } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { ChevronRight } from 'react-bootstrap-icons';
import { ChevronLeft } from 'react-bootstrap-icons';
import PendingFG from '../images/FG-no-disponible.png';
import PendingAH from '../images/AH-no-disponible.png';
import useIsInViewport from '../hooks/useIsInViewport';
import GLIFOSPdfViewer from '../viewer/GLIFOSPdfViewer';
import Loading from '../images/loading.gif';
export default function Watcher(props) {
	const { isadg, apiService, setShowWatcher } = props;
	const [canLoadMore, setCanLoadMore] = useState(true);
	const blankArray = new Array(16).fill('');
	const [collection, setCollection] = useState({
		isLoading: true,
		payload: {
			selected: null,
			collections: [],
		},
	});
	const [pagination, setPagination] = useState({
		isLoading: true,
		page: 1,
	});
	const loadMoreRef = useRef(null);
	const isLoadMoreInViewport = useIsInViewport(loadMoreRef.current);
	const [selected, setSelected] = useState({
		isLoading: false,
		collection: {},
	});

	useEffect(() => {
		try {
			if (!pagination.isLoading) return;
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: true,
			}));
			setCanLoadMore(false);
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.includes('GT-CIRMA-FG')
							? 'CIRMA-FG'
							: 'CIRMA-AH',
						isadg,
						page: pagination.page,
					},
				},
				{},
				(_, rdata) => {
					const colls = Array.isArray(rdata?.collections)
						? rdata.collections
						: [rdata?.collections];
					setCollection((prevCollection) => ({
						...prevCollection,
						isLoading: false,
						payload: {
							selected: prevCollection?.payload?.selected ?? 0,
							collections: [
								...prevCollection?.payload?.collections,
								...colls.map((col) => ({
									...col,
									id: col.id.trim(),
								})),
							],
							result_header: rdata.result_header,
						},
					}));
					setPagination((prevPagination) => ({
						isLoading: false,
						page: prevPagination.page,
					}));
					loadMoreRef.current.dataset.isloading = false;
					setCanLoadMore(true);
				}
			);
		} catch (e) {
			//console.log(e);
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		}
		return () => {
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		};
	}, [isadg, apiService, pagination]);

	/* useEffect(() => {
		console.log('isLoadMoreInViewport', isLoadMoreInViewport);
		if (
			isLoadMoreInViewport &&
			!pagination.isLoading &&
			pagination.page <
				+collection.payload?.result_header?.pagination?.total_pages
		)
			setPagination((prevPagination) => ({
				isLoading: true,
				page: prevPagination.page + 1,
			}));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoadMoreInViewport]); */
	useEffect(() => {
		//console.log('isLoadMoreInViewport', isLoadMoreInViewport);
		const dataset = loadMoreRef.current?.dataset;
		//console.log(dataset);
		if (+dataset?.currentpage >= +dataset?.totalpages) return;
		if (isLoadMoreInViewport && dataset?.isloading === 'false') {
			/* setPage((prevPage) => {
				const new_page = +prevPage + 1;
				dataset.isloading = true;
				return new_page;
			}); */
			setPagination((prevPagination) => {
				dataset.isloading = true;
				return {
					isLoading: true,
					page: prevPagination.page + 1,
				};
			});
		}
	}, [isLoadMoreInViewport, canLoadMore]);

	useEffect(() => {
		try {
			const idIsadg =
				collection.payload.collections[collection.payload.selected]?.id;
			if (!idIsadg) return;
			setSelected({
				isLoading: true,
				collection: {},
			});
			apiService.getItem(
				{ params: { childOnly: true } },
				{ isadg: idIsadg },
				(_, rdata) => {
					//console.log(rdata);
					/* console.log(
						rdata.metadata?.contenido_estructura?.alcance_contenido
					); */
					setSelected({
						isLoading: false,
						collection: rdata,
					});
				}
			);
		} catch (e) {
			console.error(e);
			setSelected({
				isLoading: false,
				collection: {},
			});
		}
		return () => {
			setSelected({
				isLoading: false,
				collection: {},
			});
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [collection.payload.selected, apiService]);

	const handleOutsideClick = (e) => {
		const itemsNotClose = document.querySelectorAll('.c-not-close');
		const closeLigthBox = Array.prototype.slice
			.call(itemsNotClose)
			.findIndex((item) => item.contains(e.target));
		if (closeLigthBox < 0) setShowWatcher(false);
	};

	return (
		<div
			className='c-watcher-container'
			onClick={handleOutsideClick}
			tabIndex={0}
			onKeyDown={(e) => e.key === 'Escape' && setShowWatcher(false)}
		>
			<Container
				className='m-0 p-0 d-flex flex-column flex-md-row w-100 h-100'
				fluid
			>
				<div className='c-content d-flex flex-column flex-grow-1'>
					<div
						className={`c-watcher position-relative ${
							collection.payload.collections?.length > 1
								? 'hasArrows'
								: ''
						}`}
					>
						<div className='c-exit position-absolute'>
							<button
								type='button'
								className='c-exit-button'
								onClick={() => setShowWatcher(false)}
							>
								<X />
							</button>
						</div>
						<div
							className='c-watcher-arrow c-not-close'
							onClick={() => {
								setCollection((prevCollection) => ({
									...prevCollection,
									payload: {
										...prevCollection.payload,
										selected:
											prevCollection.payload.selected -
												1 <
											0
												? prevCollection.payload
														.collections.length - 1
												: prevCollection.payload
														.selected - 1,
									},
								}));
							}}
						>
							<ChevronLeft />
						</div>
						{selected.isLoading && (
							<div className='c-container c-not-close'>
								<div className='light-box animated' />
								<div className='collection-info'>
									<div className='ref-code animated' />
									<div className='title animated' />
									<div className='description animated' />
								</div>
							</div>
						)}
						{!selected.isLoading && (
							<div className='c-container c-not-close'>
								<div
									className={`light-box ${
										!selected.collection?.digitalfile
											? 'bg-white'
											: ''
									}`}
								>
									{selected.collection?.digitalfile?.mime ===
									'application/pdf' ? (
										<GLIFOSPdfViewer
											file={apiService.__getFileSrc(
												selected.collection?.digitalfile
													.file_id
											)}
										/>
									) : (
										<img
											src={
												!['', 'null', 'NULL'].includes(
													collection.payload
														.collections[
														collection.payload
															.selected
													]?.thumbnail
												)
													? collection.payload
															.collections[
															collection.payload
																.selected
													  ]?.thumbnail
													: isadg.includes(
															'GT-CIRMA-FG'
													  )
													? PendingFG
													: PendingAH
											}
											alt={
												collection.payload.collections[
													collection.payload.selected
												]?.title
											}
											loading='lazy'
										/>
									)}
								</div>
								<div className='collection-info'>
									<div className='ref-code'>
										<h2>
											{
												collection.payload.collections[
													collection.payload.selected
												]?.id
											}
										</h2>
									</div>
									<div className='title'>
										<h2>
											{
												collection.payload.collections[
													collection.payload.selected
												]?.title
											}
										</h2>
									</div>
									{(selected.collection?.metadata
										?.contenido_estructura
										?.alcance_contenido?.p?.__content ||
										selected.collection?.metadata
											?.contenido_estructura
											?.alcance_contenido?.__content) && (
										<div className='description'>
											<b className='me-1'>
												Alcance y contenido:
											</b>
											{selected.collection?.metadata
												?.contenido_estructura
												?.alcance_contenido?.p
												?.__content ??
												selected.collection?.metadata
													?.contenido_estructura
													?.alcance_contenido
													?.__content}
										</div>
									)}
								</div>
							</div>
						)}

						<div
							className='c-watcher-arrow c-not-close'
							onClick={() => {
								setCollection((prevCollection) => ({
									...prevCollection,
									payload: {
										...prevCollection.payload,
										selected:
											prevCollection.payload.selected +
												1 <
											prevCollection.payload.collections
												?.length
												? prevCollection.payload
														.selected + 1
												: 0,
									},
								}));
							}}
						>
							<ChevronRight />
						</div>
					</div>
				</div>
				<div className='c-not-close c-list-col d-flex flex-row flex-wrap flex-shrink-1 '>
					<div className='c-grid'>
						{collection.payload.collections?.map((box, index) => {
							//console.log(box);
							const hasImage = !['', 'null', 'NULL'].includes(
								box?.thumbnail
							);
							const image = hasImage
								? box?.thumbnail
								: isadg.includes('GT-CIRMA-FG')
								? PendingFG
								: PendingAH;
							return (
								<div className={`c-box p-2 m-0`} key={index}>
									{/* <img
										src={image}
										alt={box?.title}
										className={
											index ===
											collection.payload.selected
												? 'selected'
												: ''
										}
										onClick={() =>
											setCollection((prevCollection) => ({
												...prevCollection,
												payload: {
													...prevCollection.payload,
													selected: index,
												},
											}))
										}
										loading='lazy'
									/> */}
									<ImgProfile
										style={{ width: 480 }}
										className={
											index ===
											collection.payload.selected
												? 'selected'
												: ''
										}
										onClick={() =>
											setCollection((prevCollection) => ({
												...prevCollection,
												payload: {
													...prevCollection.payload,
													selected: index,
												},
											}))
										}
										path={image}
										alt={box?.title}
										placeholder={Loading}
									/>
								</div>
							);
						})}
						{collection.isLoading &&
							blankArray.map((_, index) => (
								<div
									className={`c-box animated p-2 m-0`}
									key={index}
								/>
							))}
						{/* <div
							className='d-flex justify-content-center'
							id='loadMore'
							ref={loadMoreRef}
						>
							{pagination.page <
								+collection.payload?.result_header?.pagination
									?.total_pages && (
								<Spinner animation='border' role='status'>
									<span className='visually-hidden'>
										Loading...
									</span>
								</Spinner>
							)}
						</div> */}
						<div
							className='d-flex justify-content-center'
							id='loadMore'
							ref={loadMoreRef}
							data-currentpage={pagination.page}
							data-totalpages={
								collection.payload?.result_header?.pagination
									?.total_pages ?? 1
							}
							data-isloading={pagination.isLoading}
						>
							{pagination.isLoading && (
								<Spinner animation='border' role='status'>
									<span className='visually-hidden'>
										Loading...
									</span>
								</Spinner>
							)}
						</div>
					</div>
				</div>
			</Container>
		</div>
	);
}

const ImgProfile = ({ path, placeholder, loadError, alt, ...props }) => {
	const [img, initImg] = React.useState(placeholder || path);
	const onLoad = React.useCallback(() => {
		initImg(path);
	}, [path]);
	const onError = React.useCallback(() => {
		initImg(loadError || placeholder);
	}, [loadError, placeholder]);
	React.useEffect(() => {
		const imageObjt = new Image();
		imageObjt.src = path;
		imageObjt.addEventListener('load', onLoad);
		imageObjt.addEventListener('error', onError);
		return () => {
			imageObjt.removeEventListener('load', onLoad);
			imageObjt.removeEventListener('error', onError);
		};
	}, [path, onLoad, onError]);
	return <img {...props} alt={alt} src={img} />;
};
